import axios from "../../../../redux/my-axios";

export const USERS_URL = "/users";

// CREATE =>  POST: add a new customer to the server
export function createUser(user) {
  return axios.post(USERS_URL, user, { headers: { action: "post" } });
}

// READ
export function getAllUsers() {
  return axios.get(USERS_URL);
}

export function getUserById(userId) {
  return axios.post(USERS_URL, userId, { headers: { action: "select" } });
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result
export function findUsers(queryParams) {
  console.log("userCrud: findUsers ...", queryParams);
  return axios.post(USERS_URL, queryParams, { headers: { action: "get" } });
}

// UPDATE => PUT: update the user on the server
export function updateUser(user) {
  return axios.post(USERS_URL, user, { headers: { action: "put" } });
}

// UPDATE Status
export function updateUserStatus(id, status) {
  return axios.post(
    USERS_URL,
    {
      id,
      status
    },
    { headers: { action: "status" } }
  );
}

// DELETE => delete the customer from the server
export function deleteUser(userId) {
  return axios.post(USERS_URL, userId, { headers: { action: "delete" } });
}

// UPDATE Status
export function updateStatusForUsers(ids, status) {
  return axios.post(
    USERS_URL,
    {
      ids,
      status
    },
    { headers: { action: "statuses" } }
  );
}

// DELETE Customers by ids
export function deleteUsers(ids) {
  return axios.post(USERS_URL, ids, { headers: { action: "deletes" } });
}
